export class Parent {
    id: number;
    email: string;
    recovery: any;
    hash: any;
    type: string;
    status: string;
    discount: boolean;
    last_booking: any;
    parent_id: any;
    hol_parent_details: HolParentDetails[];
    holStudents: HolStudents[];
}

export class ParentItem {
    id: number;
    email: string;
    family_name: string;
    given_name: string;
    phone: number;
    hol_parent_id: number
}
export class HolParentDetails {
    // id: number;
    email: string;
    family_name: string;
    given_name: string;
    phone: number;
    relationship: string;
    // hol_parent_id: number
}
export class HolStudents {
    id: string;
    code: string;
    family_name: string;
    given_name: string;
    known_name: string;
    gender: string;
    date_of_birth: string;
    country: string;
    medical: string;
    hol_student_parents: HolStudentParents
}
export class HolStudentParents {
    hol_student_id: number;
    hol_parent_id: number;
}
export class ParentChangeEmail {
    oldEmail: string;
    newEmail: string;
    reNewEmail: string;
    constructor() {
        this.oldEmail = '';
        this.newEmail = '';
        this.reNewEmail = '';
    }
};


// WEBPACK FOOTER //
// ./src/holiday/models/Parent.ts